// HP - modified GA tracking snippet to only ensure temporary ga function
// to prevent any possible timing window where blue hasn't initialized this yet.
// Google analytics tracking snippet: https://developers.google.com/analytics/devguides/collection/analyticsjs/tracking-snippet-reference
/* jshint ignore:start */
/**
 * Creates a temporary global ga object and loads analytics.js.
 * Parameters o, a, and m are all used internally. They could have been
 * declared using 'var', instead they are declared as parameters to save
 * 4 bytes ('var ').
 *
 * @param {Window}        i The global context object.
 * @param {HTMLDocument}  s The DOM document object.
 * @param {string}        o Must be 'script'.
 * @param {string}        g Protocol relative URL of the analytics.js script.
 * @param {string}        r Global name of analytics object. Defaults to 'ga'.
 * @param {HTMLElement}   a Async script tag.
 * @param {HTMLElement}   m First script tag in document.
 */
(function(i, s, o, g, r, a, m){
  i['GoogleAnalyticsObject'] = r; // Acts as a pointer to support renaming.

  // Creates an initial ga() function.
  // The queued commands will be executed once analytics.js loads.
  if (!i[r]) {
    i[r] = function gaGazelleTemp() {
      (i[r].q = i[r].q || []).push(arguments);
    };

    // Sets the time (as an integer) this tag was executed.
    // Used for timing hits.
    i[r].l = 1 * new Date();
  }


  // HP - Don't load the script since it will be loaded in blue
  /*
   if (!i.__karma__) {
   // Insert the script tag asynchronously.
   // Inserts above current tag to prevent blocking in addition to using the
   // async attribute.
   a = s.createElement(o);
   m = s.getElementsByTagName(o)[0];
   a.async = 1;
   a.src = g;
   m.parentNode.insertBefore(a, m);
   }
   */

// HP - originally,
// })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');
})(window, document, undefined, undefined, 'ga');
